import { render, staticRenderFns } from "./ActiveWalletUsersUser.vue?vue&type=template&id=08b091af&scoped=true&"
import script from "./ActiveWalletUsersUser.vue?vue&type=script&lang=js&"
export * from "./ActiveWalletUsersUser.vue?vue&type=script&lang=js&"
import style0 from "./ActiveWalletUsersUser.vue?vue&type=style&index=0&id=08b091af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b091af",
  null
  
)

export default component.exports